//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { mapGetters } from 'vuex'
import { AXIOS, axiosGet } from '../../axios/axios.js'
import { convertTime, downloadFile } from '../../components/helpers.js'

import { convertRequestFromServer, getRequestRoles } from '../Request/Request.js'
import { shouldBlockLoadedReport, showPreviousDeferredReportWarning } from '../Report/ReportActions.js'
import { convertReportFromServer } from '../Report/Report.js'
import Request from '../Request/Request.vue'
import Report from '../Report/Report.vue'
import ReportRoads from '../ReportRoads/ReportRoads.vue'
import OrderAdmittance from '../OrderAdmittance/OrderAdmittance.vue'

import TaskButtons from './TaskButtons.vue'
import TasksGroupSettingsMenu from './TasksGroupSettingsMenu.vue'
import Table from '../../components/Table/Table.vue'
import { EventBus } from '../../EventBus/EventBus'

function getAxiosFailureFunction (target, errorMessage) {
  return (response) => {
    const message = response.message || errorMessage || 'Ошибка получения данных'
    target.$q.notify({
      type: 'negative',
      message: message,
      progress: true,
      timeout: 5000
    })
    throw new Error(message)
  }
}

function removeElementsFromArray (elements, disabledElements) {
  for (const element of elements) {
    const index = disabledElements.indexOf(element)
    if (index != -1) {
      disabledElements.splice(index, 1)
    }
  }
}

function setNodeElementsDisabledStyle (node, selector, disabledClass, additionalCondition, excludeSelector) {
  const elements = node.querySelectorAll(selector)
  return setElementsDisabledStyle(elements, disabledClass, additionalCondition, excludeSelector)
}

function setElementsDisabledStyle (elements, disabledClass, additionalCondition, excludeSelector) {
  const disabledElements = []
  elements.forEach(element => {
    if (!element.classList.contains(disabledClass) && (!additionalCondition || additionalCondition(element)) && (!excludeSelector || !element.matches(excludeSelector))) {
      element.classList.add(disabledClass)
      disabledElements.push(element)
    }
  })
  return disabledElements
}

function removeElementsDisabledStyle (disabledElements, disabledClass) {
  disabledElements.forEach(element => {
    if (element.__vue__) {
      element.classList.remove(disabledClass)
    }
  })
}

export default {
  components: {
    Request: Request,
    Report: Report,
    ReportRoads: ReportRoads,
    TaskButtons: TaskButtons,
    TasksGroupSettingsMenu: TasksGroupSettingsMenu,
    OrderAdmittance: OrderAdmittance,
    Table
  },
  props: {
    docsHeaderFixed: {
      default: false,
      type: Boolean
    }
  },
  data: function () {
    return {
      taskId: null,
      documentId: null,
      query: {},
      group: null,
      documents: [],
      bpStateId: null,
      bpStateName: null,
      reinforcements: [],

      selectedDocument: null,
      selectedDocumentType: null,
      selectedDocumentTitle: '',
      selectedDocumentRoles: {},
      selectedDocumentState: null,

      taskStatus: null,
      requestId: null,
      requestExternalName: '',
      serviceObject: null,

      request: null,
      requestInitial: null,
      requestTitle: '',
      requestRoles: {},
      requestRolesReady: false,

      currentReportId: null,
      currentReport: null, // Последний созданный отчёт по заявке
      currentReportRoles: {},
      currentReportRolesReady: false,

      collapsePanelTasksGroup: [0],
      collapsePanel: [],
      groupExpansionOpen: false,
      documentsExpansionOpen: false,

      isAuditTask: false,
      hasNotTransmittedFinishReport: false,

      allPhotosLoading: false,
      forbidden: false,

      isRouteHandled: false,

      pagination: {
        rowsPerPage: 5,
        page: 1
      },

      selectedDocuments: null,
      columnsGroup: [
        {
          name: 'requestName',
          label: 'Название задания',
          align: 'left',
          field: 'requestName',
          sortable: false
        },
        {
          name: 'bpStateName',
          label: 'Состояние задания',
          align: 'left',
          field: 'bpStateName',
          sortable: false
        }
      ],

      columns: [
        {
          name: 'name',
          label: 'Название документа',
          align: 'left',
          field: 'name',
          sortable: false
        },
        {
          name: 'typeName',
          label: 'Тип документа',
          align: 'left',
          field: 'typeName',
          sortable: false
        },
        {
          name: 'stateName',
          label: 'Состояние',
          align: 'left',
          field: 'stateName',
          sortable: false
        },
        {
          name: 'creationTime',
          label: 'Дата/время создания',
          align: 'left',
          field: 'creationTime',
          sortable: false,
          format: this.formatDataFromUnixTime
        },
        {
          name: 'changeTime',
          label: 'Дата/время редактирования',
          align: 'left',
          field: 'changeTime',
          sortable: false,
          format: this.formatDataFromUnixTime
        }
      ]
    }
  },
  computed: {
    ...mapGetters({
      taskLoading: 'getTaskLoading',
      taskStatesColors: 'getTaskStatesColors',
      reportStateColors: 'getReportStateColors',
      reportStateTextColors: 'getReportStateTextColors'
    }),
    mobile: function () {
      return this.$store.getters.getUser.view === 'mobile'
    },
    displayDocuments: function () {
      if (this.documents && this.documents.length) {
        return this.documents.length > 1 || this.documents[0].type === 'request'
      }
      return false
    },
    reinforcementsRI2: function () {
      return this.reinforcements.filter(r => r.riStateId === 'RI2')
    },
    reinforcementsRI5: function () {
      return this.reinforcements.filter(r => r.riStateId === 'RI5')
    },
    showReportStateWarning: function () {
      return !!(this.request && this.request.reportState === 'PR11')
    },
    hasFinishReportCreatedOrEditing: function () {
      return (this.documents || []).some(doc =>
        doc.type === 'requestFinishReport' &&
        (doc.stateId === 'RF1' || doc.stateId === 'RF2')
      )
    },
    reportStateColor: function () {
      return this.getReportStateColor(this.request.reportState)
    },
    reportStateTextColor: function () {
      return this.getReportStateTextColor(this.request.reportState)
    },
    reportStateLabelStyle: function () {
      const baseStyle = 'font-style: normal; font-weight: bold; margin-left: 4px; padding: 0 4px;'
      const bgColor = this.reportStateColor
      const color = this.reportStateTextColor
      return baseStyle + (bgColor && ('background-color: ' + bgColor + ';') || '') + (color && ('color: ' + color + ';') || '')
    },
    reportStateBadgeStyle: function () {
      const baseStyle = 'font-style: normal; font-weight: bold;'
      const bgColor = this.reportStateColor
      const color = this.reportStateTextColor
      return baseStyle + (bgColor && ('background-color: ' + bgColor + ';') || '') + (color && ('color: ' + color + ';') || '')
    },
    publicationReadAccess: function () {
      const user = this.$store.getters.getUser
      return !!user.hasSystemRoleStrict('publicationRead') || user.strictRestrictedAccess
    },
    displayTaskState: function () {
      return this.taskStatesColors && !this.publicationReadAccess
    },
    displayDownloadAllPhotosBtn: function () {
      const user = this.$store.getters.getUser
      if (user.hasOperation('exportRequestReportFiles')) {
        return true
      }
      return this.currentReportRoles.roleDispatcherOrHigher || this.publicationReadAccess
    }
  },
  watch: {
    '$route.params.id': {
      handler: function (result) {
        this.taskId = Number(result)
      },
      immediate: true
    },
    '$route.params.documentId': {
      handler: function (result) {
        if (result) {
          this.documentId = Number(result)
        }
      },
      immediate: true
    },
    $route: {
      handler: function (route, prevRoute) {
        if (route && route.path && prevRoute && prevRoute.path && route.path === prevRoute.path) {
          // same path
          const query = route.query
          const prevQuery = prevRoute.query
          if (query && query.multiple != null && prevQuery && prevQuery.multiple != null && query.multiple !== prevQuery.multiple) {
            console.log('report "multiple" changed:', query.multiple, '=>', prevQuery.multiple)

            this.onUpdateDocuments(null, false, false)
          }
        }
      },
      immediate: true
    },
    '$route.query': {
      handler: function (result) {
        this.query = result
      },
      immediate: true
    },
    taskId: {
      handler: function (result) {
        if (result) {
          this.loadDocuments().then(
            (documents) => {
              if (this.documentId === null || this.documentId === undefined || isNaN(this.documentId)) {
                if (this.displayReport(this.bpStateId)) {
                  let index = documents.findIndex(doc => {
                    return doc.current === true
                  })

                  if (index === -1) {
                    index = 0
                  }

                  this.documentSelected(documents[index], true, index)
                  this.$emit('task-updated')
                } else {
                  this.documentSelected(documents[0], true, 0)
                }
              } else {
                let index = documents.findIndex(doc => {
                  return doc.id === this.documentId
                })

                if (index === -1) {
                  index = 0
                }

                this.documentSelected(documents[index], true, index)
                this.$emit('task-updated')
              }
            }
          )
        }
      },
      immediate: true
    },
    'taskLoading.active': function (active) {
      if (active) {
        this.disableElements(this.taskLoading)
      } else {
        this.enableElements()
      }
    }
  },
  created: function () {
    if (this.mobile) {
      this.columns = this.columns.filter(column => column.name === 'name' || column.name === 'stateName')
    }
  },
  mounted () {
    window.addEventListener('beforeunload', this.handleBeforeUnload)
  },
  beforeDestroy () {
    window.removeEventListener('beforeunload', this.handleBeforeUnload)

    this.disabledElements = null
    this.disabledFieldsElements = null
    this.enableElements()
    this.$store.dispatch('setTaskLoading', null)
  },
  methods: {
    disableElements: function (loadingActivity) {
      const vm = this
      const taskDocumentsEl = this.$el

      const editSelector = '.d-action--edit, .d-input--edit'
      const disabledSelector = '.d-btn, ' + editSelector
      const fieldsSelector = '.q-field:not(.q-field--readonly), .q-field.q-field--readonly.d-field-editable'
      // const fieldCondition = element => element.__vue__ && !(element.__vue__.readonly || element.__vue__.disabled || element.classList.contains('q-field--readonly'))
      // const inertSelector = '.q-toggle, q-checkbox'
      const excludeSelector = '.d-action--view, .d-input--view'
      const sumSelector = disabledSelector + ', ' + fieldsSelector + ', ' + excludeSelector //  + ', ' + inertSelector
      const editOrViewSelector = editSelector + ', ' + excludeSelector

      const additionalMatchFunction = function (element) {
        if (element.matches(excludeSelector)) {
          return false
        }
        if (element.parentElement) {
          const matchingParent = element.parentElement.closest(editOrViewSelector)
          if (matchingParent && matchingParent.matches(excludeSelector)) {
            return false
          }
        }
        return true
      }

      this.handleGlobalClick = function (event) {
        // Проверяем, есть ли у кликнутого элемента (или его родителей) нужный класс
        let target = event.target.closest(sumSelector)
        if (!target) {
          const elements = document.elementsFromPoint(event.clientX, event.clientY)
          for (const element of elements) {
            if (element === event.target) {
              break
            }
            if (element.matches(sumSelector)) {
              target = element
              break
            }
          }
        }

        if (target) {
          if (!additionalMatchFunction(target)) {
            return
          }

          event.stopImmediatePropagation()
          event.stopPropagation()
          event.preventDefault()

          const warnings = ['Ожидайте выполнения предыдущей операции']
          if (loadingActivity && loadingActivity.actionName) {
            warnings.push(':\n', loadingActivity.actionName)
          }

          vm.$q.notify({
            type: 'warning',
            spinner: true,
            message: warnings.join(''),
            timeout: 5000
          })
        }
      }
      setTimeout(() => {
        taskDocumentsEl.addEventListener('click', this.handleGlobalClick, true)
      }, 0)

      this.disabledElements = []
      this.disabledFieldsElements = []

      const setChildrenDisabled = parentElement => {
        this.disabledElements.push(...setNodeElementsDisabledStyle(parentElement, disabledSelector, 'disabled', additionalMatchFunction, excludeSelector))
        this.disabledFieldsElements.push(...setNodeElementsDisabledStyle(parentElement, fieldsSelector, 'q-field--disabled', additionalMatchFunction, excludeSelector))
      }
      setChildrenDisabled(taskDocumentsEl)

      const mutationObserver = new MutationObserver((mutations) => {
        for (const mutation of mutations) {
          if (mutation.type === 'childList') {
            mutation.addedNodes.forEach((node) => {
              // node — это добавленный узел (может быть текстовым!)
              if (node.nodeType === Node.ELEMENT_NODE) {
                // console.log('Добавлен элемент:', node)

                setChildrenDisabled(node)
              }
            })

            mutation.removedNodes.forEach((node) => {
              if (node.nodeType === Node.ELEMENT_NODE) {
                // console.log('Удалён элемент:', node)

                removeElementsFromArray(node.querySelectorAll(disabledSelector), this.disabledElements)
                removeElementsFromArray(node.querySelectorAll(fieldsSelector), this.disabledFieldsElements)
              }
            })
          }
        }
      })
      mutationObserver.observe(taskDocumentsEl, {
        childList: true, // следить за добавлением/удалением дочерних узлов
        subtree: true // и во всех вложенных уровнях, а не только прямых детей
      })
      this.mutationObserver = mutationObserver
    },
    enableElements: function () {
      if (this.disabledElements) {
        removeElementsDisabledStyle(this.disabledElements, 'disabled')
        this.disabledElements = null
      }
      if (this.disabledFieldsElements) {
        removeElementsDisabledStyle(this.disabledFieldsElements, 'q-field--disabled')
        this.disabledFieldsElements = null
      }

      if (this.handleGlobalClick) {
        const taskDocumentsEl = this.$el
        taskDocumentsEl.removeEventListener('click', this.handleGlobalClick, true)
      }
      if (this.mutationObserver) {
        this.mutationObserver.disconnect()
      }
    },

    handleBeforeUnload (event) {
      if (this.hasReportChanges()) {
        event.preventDefault()
        event.returnValue = ''
      }
    },
    onClickReinforcements: function () {
      EventBus.$emit('show-reinforcements')
    },
    onDownloadAllPhotos: function () {
      this.allPhotosLoading = true
      downloadFile('/service/delta/request/downloadPhotos?id=' + this.request.requestId, () => {
        this.allPhotosLoading = false
      }, this)
    },
    closeIfTerminalState: function (event) {
      // console.log('checking if terminal state is ' + this.bpStateId + ' or ' + (this.currentReport ? this.currentReport.stateId : 'null'))
      if (this.bpStateId == 'BS13' ||
        (this.currentReport && (
          this.currentReport.stateId == 'PR4' ||
          this.currentReport.stateId == 'PR10' ||
          this.currentReport.stateId == 'PR11' && event && event.businessProcess === 'requestBusinessProcess' && event.status == 'success')
        )
      ) {
        EventBus.$emit('update-tasks')
        this.$router.push('/tasks')
      }
    },
    groupTaskSelected: function (task) {
      if (this.isSelectedTaskGroup(task)) {
        return
      }

      this.selectedDocument = null // Чтобы корректно отработал prepareCurrentReport()

      let documentSuffix
      if (task.reportId) {
        if (this.query.multiple == null) {
          documentSuffix = task.reportId
        } else {
          documentSuffix = task.reportId + '?multiple=' + (this.query.multiple === 'true')
        }
      } else {
        documentSuffix = task.requestId
      }
      this.$router.replace('/task/' + task.requestId + '/document/' + documentSuffix)
    },
    setGroup: function (group) {
      if (group != null) {
        if (!this.group) {
          this.group = group
        } else {
          this.group.name = group.name
          this.group.type = group.type
          this.group.items = group.items
        }

        const taskIndex = this.group.items.findIndex(item => item.requestId === this.taskId || item.bpContextId === this.taskId)
        // console.log(taskIndex, this.group.items, this.group.items[taskIndex])
        if (taskIndex !== -1) {
          this.$nextTick(() => {
            this.$set(this.group.items[taskIndex], 'isChecked', true)
            // console.log('***', this.group.items[taskIndex], this.group.items[taskIndex].isChecked)
            // this.$refs.tasksGroupTable.
            // this.$refs.tasksGroupTable.data.setIsChecked(this.group.items[taskIndex])
            // this.$refs.tasksGroupTable.$el.setRowSelect(this.group.items[taskIndex])
          })
        }
      } else if (!!this.request && !this.request.group && (!this.currentReport || !this.currentReport.multiReport)) {
        this.group = null
      }
    },
    onDocumentsTableClick: function (data) {
      if (this.mobile && data && data.type === 'requestReport') {
        const report = this.getLoadedReportByDocument(data)
        if (shouldBlockLoadedReport(this.request, report)) {
          showPreviousDeferredReportWarning(this)
          return
        }
      }
      this.documentSelected(data)
    },
    getLoadedReportByDocument: function (data) {
      if (!data) {
        return null
      }
      if (this.currentReport && this.currentReport.id === data.id) {
        return this.currentReport
      }
      if (this.request && this.request.reports && this.request.reports.length) {
        const fromRequest = this.request.reports.find(report => report.id === data.id)
        if (fromRequest) {
          return fromRequest
        }
      }
      return data
    },
    documentSelected: function (data, tryNotReload = false, index = -1) {
      console.log('documentSelected', data)
      this.selectedDocuments = data

      if (this.pagination.rowsPerPage * this.pagination.page < (index + 1)) {
        this.pagination.page = Math.ceil((index + 1) / this.pagination.rowsPerPage)
      }

      this.selectedDocumentType = undefined

      // Если выбрана не главная заявка в задании, то при выборе этой заявки переходим в её задание.
      if (data.type === 'request' && data.id !== this.requestId) {
        this.$router.replace('/task/' + data.id + '/document/' + data.id)
        return
      }

      const newPath = '/task/' + this.taskId + '/document/' + data.id
      if (this.$router.currentRoute.path !== newPath) {
        this.$router.replace(newPath)
      }

      if (data.type == 'request') {
        (tryNotReload && this.request && this.request.requestId === data.id ? Promise.resolve() : this.prepareRequestRoles())
          .then(
            () => {
              this.selectedDocument = this.request
              this.selectedDocumentTitle = this.requestTitle
              this.selectedDocument.id = data.id
              this.selectedDocumentType = 'request'
            }
          )
      } else if (data.type == 'requestReport') {
        this.showRequestReportDocument(data, tryNotReload)
      } else if (data.type == 'requestFinishReport') {
        AXIOS.get('/service/delta/finishreport/' + data.id)
          .then(
            (response) => {
              const reportRoads = response.data.result
              this.taskStatus = data.stateId
              this.selectedDocument = reportRoads
              this.selectedDocument.id = data.id
              this.selectedDocumentTitle = data.name
              this.selectedDocumentType = 'requestFinishReport'
              this.selectedDocumentState = data.stateName
            }
          )
      } else if (data.type == 'orderadmittance') {
        this.selectedDocumentType = 'orderAdmittance'
        this.selectedDocument.id = data.id
      }
    },
    showRequestDocumentInsteadOfBlockedReport: function () {
      const requestDoc = this.documents.find(doc => doc.type === 'request' && doc.id === this.requestId) ||
        this.documents.find(doc => doc.type === 'request')
      if (requestDoc) {
        this.documentSelected(requestDoc, true)
        return
      }
      if (this.taskId) {
        const requestPath = '/task/' + this.taskId
        if (this.$router.currentRoute.path !== requestPath) {
          this.$router.replace(requestPath)
        }
      }
    },
    showRequestReportDocument: function (data, tryNotReload = false) {
      // formId и id используются для фиксации просмотра
      let url = '/service/delta/report/' + data.id + '?formId=report&id=' + data.id + '&includeWorksHistoryRecords=' + !this.mobile
      if (this.query.multiple === 'false') {
        url += '&multiple=false'
      }

      let reportPromise
      if (tryNotReload && this.currentReport && this.currentReport.id === data.id && this.query.multiple !== 'false') {
        console.log('selected document1', this.currentReport.id, data.id)

        reportPromise = Promise.resolve(this.currentReport)
      } else {
        console.log('selected document2 load', this.currentReport && this.currentReport.id, data.id)

        reportPromise = axiosGet({
          url,
          onSuccess: (response) => convertReportFromServer(response.data.result, this.$store.getters.getUser),
          onFailure: getAxiosFailureFunction(this, 'Ошибка получения данных отчёта')
        })
      }
      this.$q.loading.show({ spinnerColor: 'light-green-11' })
      reportPromise
        .then(
          (report) => {
            if (report.reports) {
              if (this.query.multiple != null) {
                this.$router.replace(this.$router.currentRoute.path + '?multiple=' + this.query.multiple)
              } else {
                this.$router.replace(this.$router.currentRoute.path + '?multiple=true')
              }
            } else if (report.multiReport) {
              this.$router.replace(this.$router.currentRoute.path + '?multiple=false')
            }

            if (report.multiReport) {
              this.setGroup({
                name: 'ГРУППА ЗАДАНИЙ СО СВОДНЫМ ОТЧЁТОМ',
                type: 'multiReport',
                items: report.multiReport.items
              })
            } else {
              this.setGroup(null)
            }

            if (this.mobile && shouldBlockLoadedReport(this.request, report)) {
              this.showRequestDocumentInsteadOfBlockedReport()
              this.$nextTick(() => {
                showPreviousDeferredReportWarning(this)
              })
              return
            }

            this.taskStatus = report.bpStateId
            this.selectedDocument = report
            this.selectedDocumentTitle = report.name
            this.selectedDocument.id = data.id
            this.selectedDocumentRoles = report._roles
            this.selectedDocumentType = 'requestReport'
            if (this.selectedDocument.id === this.currentReportId) {
              this.selectedDocument.current = true
              this.currentReport = report
            }
          }
        )
        .finally(() => {
          this.$q.loading.hide()
        })
    },
    onUpdateDocuments: function (event, openReportRoads = false, needCloseIfTerminateStatus = true) {
      const selectedDocumentId = this.selectedDocument.id
      let reportsIds
      if (event && event.checkNewReport === true) {
        reportsIds = new Set(this.documents.filter(doc => {
          return doc.type === 'requestReport'
        }).map(doc => {
          return doc.id
        }))
      }

      this.loadDocuments()
        .then(
          (documents) => {
            let index
            if (!openReportRoads) {
              if (event && event.checkNewReport === true) {
                index = documents.findIndex(doc => {
                  return doc.type === 'requestReport' && !reportsIds.has(doc.id)
                })
              }
            } else {
              const indexInReversedArray = documents
                .slice()
                .reverse()
                .findIndex(doc => doc.type === 'requestFinishReport')

              if (indexInReversedArray !== undefined && indexInReversedArray !== null) {
                index = documents.length - indexInReversedArray - 1
              }
            }

            if (index == null || index === -1) {
              index = documents.findIndex(doc => {
                return doc.id === selectedDocumentId
              })
              if (index === -1) {
                index = 0
              }
            }

            this.documentSelected(documents[index], true, index)
            this.$emit('task-updated')

            if (this.mobile && needCloseIfTerminateStatus) {
              this.closeIfTerminalState(event)
            }
          }
        )
    },
    loadDocuments: function () {
      this.$q.loading.show({ spinnerColor: 'blue-11' })
      return axiosGet({
        url: '/service/delta/request/documents?id=' + this.taskId,
        onSuccess: (response) => {
          if (this.forbidden) {
            this.forbidden = false
          }
          if (response.data.result.bpStateId != 'BS1') {
            this.setDocumentsServiceResult(response.data.result)
            return Promise.resolve()
          } else {
            return AXIOS.get('/service/delta/request/documents?id=' + this.taskId + '&takeToWork=true')
              .then((response) => {
                this.$emit('task-updated')
                this.setDocumentsServiceResult(response.data.result)
              })
          }
        },
        onFailure: (response) => {
          if (response.code === 'forbidden' || response.type === 'forbidden') {
            this.forbidden = true
          }
          return getAxiosFailureFunction(this, 'Ошибка получения данных документооборота заявки')(response)
        }
      })
        .then(() => {
          return this.prepareRequestRoles()
        })
        .then(() => {
          return this.prepareCurrentReport()
        })
        .then(() => {
          return Promise.resolve(this.documents)
        })
        .finally(() => {
          this.$q.loading.hide()
        })
    },
    setDocumentsServiceResult: function (serverResult) {
      this.requestId = serverResult.requestId
      this.requestExternalName = serverResult.requestExternalName
      this.isAuditTask = !!(serverResult.audit || serverResult.auditObject)
      this.documents = this.prepareDocuments(serverResult.documents)
      this.bpStateId = serverResult.bpStateId
      this.bpStateName = serverResult.bpStateName
    },
    prepareDocuments: function (documents) {
      let lastReport = null

      const requestDocument = documents.length && documents[0].type === 'request' && documents[0] || null
      if (requestDocument) {
        if (this.requestExternalName) {
          requestDocument.name = this.requestExternalName + ' / ' + requestDocument.name
        }
        this.requestTitle = requestDocument.name
      }

      this.hasNotTransmittedFinishReport = false
      documents.forEach(doc => {
        if (doc.type === 'requestReport' && (lastReport == null || lastReport.creationTime < doc.creationTime)) {
          lastReport = doc
        }

        if (doc.type == 'requestFinishReport') {
          if (doc.stateId !== 'RF3') {
            this.hasNotTransmittedFinishReport = true
          }
        }
      })

      if (lastReport != null) {
        lastReport.current = true
        this.currentReportId = lastReport.id
      } else {
        this.currentReportId = null
      }

      return documents
    },
    prepareRequestRoles: function () {
      this.requestRolesReady = false

      return axiosGet({
        url: '/service/delta/request/getRequest?id=' + this.requestId,
        onSuccess: (response) => {
          let request = response.data.result
          this.serviceObject = request.serviceObject
          this.reinforcements = request.riAssignedBrigades || []

          this.setGroup(request.group)
          this.taskStatus = request.bpStateId

          const user = this.$store.getters.getUser
          this.requestInitial = convertRequestFromServer(JSON.parse(JSON.stringify(request)), user)
          request = convertRequestFromServer(request, user)
          request.initialObject = this.requestInitial
          this.request = request

          this.requestRoles = getRequestRoles(this.request, user, 'taskCard')
          this.requestRolesReady = true
        },
        onFailure: getAxiosFailureFunction(this, 'Ошибка получения данных заявки')
      })
    },
    prepareCurrentReport: function () {
      console.log('prepareCurrentReport this.currentReportId', this.currentReportId)
      this.currentReportRolesReady = false
      if (this.currentReportId) {
        const selectedDocumentId = this.selectedDocument ? this.selectedDocument.id : this.documentId
        const currentReportOpened = selectedDocumentId != null ? selectedDocumentId === this.currentReportId : this.displayReport(this.bpStateId)
        this.$q.loading.show({ spinnerColor: 'cyan-11' })
        return axiosGet({
          url: '/service/delta/report/' + this.currentReportId + '?includeWorksHistoryRecords=' + !this.mobile + (currentReportOpened ? '&formId=report&id=' + this.currentReportId : ''), // formId и id используются для фиксации просмотра
          onSuccess: (response) => {
            const report = convertReportFromServer(response.data.result, this.$store.getters.getUser)
            report.current = true
            this.currentReportRoles = report._roles
            this.currentReport = report
            this.currentReportRolesReady = true

            if (report.multiReport && !currentReportOpened) {
              // Если даже отчёт не открыт, но он является единственным для задания, то отображаем его группу заданий со сводным отчётом
              const reportsCount = this.documents.reduce((reportsCount, doc) => (doc.type === 'requestReport' ? ++reportsCount : reportsCount), 0)
              if (reportsCount === 1) {
                this.setGroup({
                  name: 'ГРУППА ЗАДАНИЙ СО СВОДНЫМ ОТЧЁТОМ',
                  type: 'multiReport',
                  items: report.multiReport.items
                })
              }
            }
          },
          onFailure: getAxiosFailureFunction(this, 'Ошибка получения данных отчёта')
        })
          .finally(() => {
            this.$q.loading.hide()
          })
      } else {
        this.currentReportRolesReady = true
        return Promise.resolve()
      }
    },
    formatDataFromUnixTime: function (unixTime) {
      if (unixTime != null) {
        return convertTime(unixTime)
      } else {
        return 'Нет данных'
      }
    },
    onDefaultRemark: function (remark) {
      this.currentReport.defaultRemark = remark
    },
    hexToRgb: function (hex, alpha) {
      hex = hex.replace('#', '')

      const r = parseInt(hex.length == 3 ? hex.slice(0, 1).repeat(2) : hex.slice(0, 2), 16)
      const g = parseInt(hex.length == 3 ? hex.slice(1, 2).repeat(2) : hex.slice(2, 4), 16)
      const b = parseInt(hex.length == 3 ? hex.slice(2, 3).repeat(2) : hex.slice(4, 6), 16)

      if (alpha) {
        return `rgba(${r},${g},${b},${alpha})`
      } else {
        return `rgb(${r},${g},${b})`
      }
    },
    getBpStateStyles: function () {
      const backgroundColor = this.taskStatesColors[this.bpStateId] || '#000000'
      const color = backgroundColor === '#0000FF' || backgroundColor === '#828282' || backgroundColor === '#000000' ? 'white' : 'black'

      return `background: linear-gradient(45deg, ${this.hexToRgb(backgroundColor, 1)} 30%, ${this.hexToRgb(backgroundColor, 0.85)} 30%, ${this.hexToRgb(backgroundColor, 0.7)} 40%);
              color: ${color};`
    },
    beforeRouteLeaveMethod: function (to, from, next) {
      if (this.isRouteHandled) {
        next()
        return
      }

      if (this.hasReportChanges()) {
        this.close(next)
      } else {
        next()
      }
    },
    close: function (next) {
      if (this.hasReportChanges()) {
        this.$d_ask({
          callback: async (data, action) => {
            if (action === 'yes') {
              await this.saveReport(false)
              this.finishRoute(next)
            } else if (action === 'no') {
              this.finishRoute(next)
            } else if (action === 'cancelCustom') {
              next(false)
            }
          },
          header: 'Сохранить изменения в отчёте?',
          buttons: {
            yes: 'Сохранить',
            no: 'Не сохранять',
            cancelCustom: 'Отмена'
          }
        })
      } else {
        this.finishRoute(next)
      }
    },
    finishRoute: function (next) {
      this.isRouteHandled = true
      EventBus.$emit('task-closed')

      if (next) {
        next()
      } else {
        this.routerPushBack()
      }
    },
    routerPushBack: function () {
      if (window.history.length > 1 && window.history.state !== null) {
        this.$router.back()
      } else {
        this.$router.push('/')
      }
    },
    hasReportChanges: function () {
      if (this.currentReport != null && this.$refs.report) {
        return this.currentReport._reportManager.hasChanges()
      }
      return false
    },
    saveReport: async function (updateDocuments = true) {
      const report = this.currentReport
      if (report != null && this.$refs.report) {
        let changed
        try {
          changed = await report._reportManager.saveChanges({ target: this })
        } catch (error) {
          changed = !!error.result
          throw new Error('Невозможно сохранить отчёт')
        } finally {
          this.$q.loading.hide()

          if (changed && updateDocuments) {
            this.$nextTick(() => {
              this.onUpdateDocuments()
            })
          }
        }
      }
    },
    displayReport: function (bpStateId) {
      return bpStateId == 'BS4' ||
             bpStateId == 'BS5' ||
             bpStateId == 'BS6' ||
             bpStateId == 'BS7' ||
             bpStateId == 'BS8' ||
             bpStateId == 'BS14' ||
             bpStateId == 'BS15' ||
             bpStateId == 'BS17' ||
             this.openReport === true
    },
    isSelectedTaskGroup: function (group) {
      return this.requestId === group.requestId
    },
    getTdStyle: function (col, row) {
      if (col.name === 'stateName' && row.type === 'requestReport' && row.stateId == 'PR11') {
        const bgColor = this.getReportStateColor(row.stateId)
        if (bgColor) {
          return 'background-color: ' + bgColor + ' !important;'
        }
      }
      return null
    },
    getReportStateColor: function (stateId) {
      return this.reportStateColors && stateId && this.reportStateColors[stateId] || null
    },
    getReportStateTextColor: function (stateId) {
      return this.reportStateTextColors && stateId && this.reportStateTextColors[stateId] || null
    }
  }
}

